import { Button, Dialog, DialogContent } from "@/shared";
import { Dropdown, DropdownItem } from "@/shared/components/ui/Dropdown";
import { Filter } from "lucide-react";
import { useTranslation } from "react-i18next";

const InvoiceFilterDialog = ({ dialog, setDialog, onCloseDialog, setAppliedInvoiceType }: any) => {
    const { t } = useTranslation();

    return (
        <Dialog open={dialog.open} onOpenChange={onCloseDialog}>
            <DialogContent
                onClose={onCloseDialog}
                className="max-w-md p-0 overflow-hidden rounded-2xl">
                <div className="bg-slate-50 p-6 border-b border-slate-100 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <div className="p-2 bg-violet-100 text-violet-600 rounded-lg">
                            <Filter size={20} />
                        </div>
                        <h2 className="text-xl font-bold text-slate-800">{t("filter_options")}</h2>
                    </div>

                </div>

                <div className="p-8 space-y-6">
                    <div className="space-y-3">
                        <label className="text-sm font-black text-slate-500 uppercase tracking-wider">
                            {t("invoice_type")}
                        </label>
                        <Dropdown
                            label={dialog.invoiceType ? t(dialog.invoiceType) : t("select_type")}
                        >
                            <DropdownItem onClick={() => setDialog({ ...dialog, invoiceType: 'all_types' })}>{t("all_types")}</DropdownItem>
                            <DropdownItem onClick={() => setDialog({ ...dialog, invoiceType: 'Sell' })}>{t("Sell")}</DropdownItem>
                            <DropdownItem onClick={() => setDialog({ ...dialog, invoiceType: 'Buy' })}>{t("Buy")}</DropdownItem>
                            <DropdownItem onClick={() => setDialog({ ...dialog, invoiceType: 'ReturnSell' })}>{t("ReturnSell")}</DropdownItem>
                            <DropdownItem onClick={() => setDialog({ ...dialog, invoiceType: 'ReturnBuy' })}>{t("ReturnBuy")}</DropdownItem>
                        </Dropdown>
                    </div>
                </div>

                <div className="p-6 bg-slate-50 border-t border-slate-100 flex gap-3">
                    <Button
                        className="flex-1 bg-violet-600 hover:bg-violet-700 text-white shadow-lg shadow-violet-200"
                        onClick={() => {
                            setAppliedInvoiceType(dialog.invoiceType);
                            onCloseDialog();
                        }}
                    >
                        {t("apply_filter")}
                    </Button>
                    <Button
                        variant="outline"
                        className="flex-1 border-slate-200 text-slate-600 hover:bg-slate-100"
                        onClick={onCloseDialog}
                    >
                        {t("cancel")}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}


export default InvoiceFilterDialog